var map = {
	"./about/about_pic1.png": "KXcr",
	"./about/about_pic2.png": "KxU1",
	"./about/about_pic3.png": "9BZd",
	"./about/about_pic4.png": "Ri6L",
	"./about/about_pic5.png": "iB3O",
	"./about/au/melbourne.png": "H+C9",
	"./about/au/sydney.png": "mf4s",
	"./about/ca_map.png": "hFaE",
	"./about/canada/Alberta.png": "e+xp",
	"./about/canada/Manitoba.png": "V/iJ",
	"./about/canada/NAL.png": "fGwk",
	"./about/canada/Ontario.png": "BW3w",
	"./about/canada/Quebec.png": "/lHI",
	"./about/canada/Saskatchewan.png": "DowM",
	"./about/canada/bc.png": "t+tq",
	"./about/canada/others.png": "AYIT",
	"./about/head-pic1.png": "Kila",
	"./about/head-pic2.png": "F97f",
	"./about/head-pic3.png": "2zKF",
	"./about/uk/London.png": "hGAi",
	"./about/uk/Sheffield.png": "SAk7",
	"./about/us_map.png": "dq9g",
	"./about/usa/LA.png": "DlQi",
	"./about/usa/newyork.png": "2zCN",
	"./about/usa/seattle.png": "7Z+m",
	"./dianping.png": "Xem5",
	"./drive-eta-trans@2x.png": "Qpnf",
	"./earth.png": "zjCx",
	"./earth@2x.png": "D8XC",
	"./earth_colored.png": "x/Zx",
	"./facebook@2x.png": "iy+4",
	"./fantuan-en.png": "l48Z",
	"./fantuan-en_.png": "arS7",
	"./fantuan-zh.png": "4SRh",
	"./fantuan-zh_.png": "tlLg",
	"./fantuan_logo.png": "YGzF",
	"./ico.png": "YHj2",
	"./icon_lefttarrows.png": "4VmW",
	"./icon_rightarrows.png": "koF3",
	"./instagram@2x.png": "pUkD",
	"./jobs/job-banner1.png": "OrS7",
	"./jobs/job-banner2.png": "4M8N",
	"./jobs/job-banner3.png": "1Xcv",
	"./linked-in@2x.png": "FUIi",
	"./logo-en.png": "CBFq",
	"./logo-en_.png": "ywd7",
	"./logo-zh.png": "Pp7w",
	"./logo-zh_.png": "BJJ5",
	"./logo_footer.png": "7a4a",
	"./record.png": "ypkM",
	"./time_0.png": "wn/S",
	"./time_1.png": "7068",
	"./time_2.png": "ZwRK",
	"./time_3.png": "7YyE",
	"./time_4.png": "NS84",
	"./time_5.png": "Eev9",
	"./weibo@2x.png": "Pjr5",
	"./youtube@2x.png": "RW+D"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1IgP";